import { render, staticRenderFns } from "./sealaw.vue?vue&type=template&id=e61e97da&scoped=true&"
import script from "./sealaw.vue?vue&type=script&lang=js&"
export * from "./sealaw.vue?vue&type=script&lang=js&"
import style0 from "./sealaw.vue?vue&type=style&index=0&id=e61e97da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61e97da",
  null
  
)

export default component.exports